import { isArray, isNil } from 'lodash';

import type { IAny } from '~/helpers/types';

export const isFieldValueEmpty = (value: IAny): boolean =>
  isNil(value) || value === '' || (isArray(value) && value.length === 0);
